import React, { Component } from 'react';
import Layout from './components/Layout';
import Login from './components/Login';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Const from './const';

class App extends Component {
  render() {
    const skinType = Const.skinType.toUpperCase();
    const GogoitButtonContainer = styled.div`
      .ant-btn:focus {
        color: #1ecad3;
        border-color: #1ecad3;
      }
      .ant-btn:hover {
        color: #1ecad3;
        border-color: #1ecad3;
      }
      .ant-btn-primary {
        background-color: #000;
        border-color: #000;
        background: #000;
      }
      .ant-btn-primary:hover {
        background-color: #1ecad3;
        border-color: #1ecad3;
        background: #1ecad3 !important;
        color: #000 !important;
      }
      .ant-pagination-item-active,
      .ant-pagination-item-active:hover {
        border-color: #1ecad3;
      }
      .ant-pagination-item-active a,
      .ant-pagination-item-active a:hover {
        color: #1ecad3;
      }
    `;
    return (
      <BrowserRouter>
        <Switch>
          {skinType === 'GOGOIT' ? (
            <GogoitButtonContainer>
              <Route exact path="/" component={Login} />
              <Route path="/:page" component={Layout} />
            </GogoitButtonContainer>
          ) : (
            <>
              <Route exact path="/" component={Login} />
              <Route path="/:page" component={Layout} />
            </>
          )}
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
